/* unplugin-vue-components disabled */import { render } from "./FlowsHistory.vue?vue&type=template&id=19ae11f1"
import script from "./FlowsHistory.vue?vue&type=script&lang=js"
export * from "./FlowsHistory.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__